import { HDNodeWallet, Signer, Wallet } from 'ethers';

import { ConnectSuccessData, GetWalletAPI } from '../WalletAPI';

export function guestAPI({
  addressGetter,
}: {
  addressGetter: () => string | undefined;
}): GetWalletAPI {
  return ({ type }) => {
    let setPrivateWallet: (wallet: HDNodeWallet) => void;
    const privateWalletPromise: Promise<HDNodeWallet> = new Promise((res) => {
      setPrivateWallet = res;
    });

    return {
      type,
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      getSigner: (): Promise<Signer> => privateWalletPromise as Promise<Signer>,
      connect: ({ chainInfo }): Promise<ConnectSuccessData> => {
        const privateWallet = Wallet.createRandom();
        setPrivateWallet(privateWallet);

        const address = addressGetter();
        const chainId = parseInt(chainInfo.chainId, 10);

        if (address === undefined || !chainId) {
          throw new Error(
            'Wallet address or chainId is undefined. Try to reload the page',
          );
        }

        return Promise.resolve({
          address,
          chainId,
        });
      },
    };
  };
}
